import { useEffect } from 'react';

// Language prefixes used by the localized SEO routes
// (/en/rent/…, /es/alquilar/…, /fr/louer/…, /de/mieten/…, /it/noleggiare/…, /nl/huren/…).
const PATH_LANG = { en: 'en', es: 'es', fr: 'fr', de: 'de', it: 'it', nl: 'nl' };

// Dutch routes exist in the router but have no translated content — they render
// the Portuguese page. They must not be indexed (and must keep lang="pt-PT",
// because the visible content is Portuguese, not Dutch).
const UNTRANSLATED_LANGS = ['nl'];

/**
 * Keeps <html lang> in sync with the localized route and de-indexes routes that
 * have no translation. Called from the app root so it runs after the page's own
 * effects and therefore wins — the static index.html declares lang="pt-PT",
 * which Google was reading on the Italian and French pages.
 */
export function useLocalizedRouteMeta(pathname) {
  useEffect(() => {
    const segment = (pathname || '').split('/').filter(Boolean)[0];
    const lang = PATH_LANG[segment];

    // Unprefixed (Portuguese) route: leave lang untouched. Pages that render
    // translated content from ?lang=xx set their own value.
    if (!lang) return;

    if (UNTRANSLATED_LANGS.includes(lang)) {
      const meta = document.querySelector('meta[name="robots"]')
        || document.head.appendChild(Object.assign(document.createElement('meta'), { name: 'robots' }));
      meta.setAttribute('content', 'noindex, follow');
      return;
    }

    document.documentElement.lang = lang;
  }, [pathname]);
}

export default useLocalizedRouteMeta;